import { ToolPageModule } from './tool/tool.module';
import { ResetPasswordPageModule } from './resetPassword/resetPassword.module';
import { RegistrationPageModule } from './registration/registration.module';
import { ForgottenPasswordPageModule } from './forgotPassword/forgottenPassword.module';
import { CompleteRegistrationPageModule } from './completeRegistration/completeRegistration.module';
import { LoginPageModule } from './login/login.module';
import { AppRoutingModule } from './app-routing.module';
import { IonicModule } from '@ionic/angular';
import { NgModule } from '@angular/core';
import { BrowserModule, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { AndroidPermissions } from '@ionic-native/android-permissions/ngx';
import { File } from '@ionic-native/file/ngx';
import { FileTransfer, FileTransferObject } from '@ionic-native/file-transfer/ngx';
import { FileOpener } from '@ionic-native/file-opener/ngx';
import { Deeplinks } from '@ionic-native/deeplinks/ngx';
import { CacheModule } from 'ionic-cache';
import { KnobModule } from 'ng2-knob';
import { NouisliderModule } from 'ng2-nouislider';
import { App } from './app.component';

import { Utils } from '../service/utils';
import { Constants } from '../service/constants';
import { ImageConstants } from '../service/image-constants';
import { ApplicationConfig } from '../config';
import { MaterialProvider } from './tool/material/material.service';
import { EndmillProvider } from './tool/endmill/endmill.service';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReactiveFormsModule } from '@angular/forms';

import { ErrorDialog } from '../service/dialog/error/error';
import { AlertDialog } from '../service/dialog/alert/alert';
import { ConfirmDialog } from '../service/dialog/confirm/confirm';
import { GCodeDialog } from '../service/dialog/gCode/gCode';
import { PdfInfoDialog } from '../service/dialog/pdfInfo/pdfInfo';
import { WorkOfflineDialog } from '../service/dialog/workOffline/workOffline';

import { ConversionFormulas } from '../service/formulas/conversionsFormulas';
import { Formulas } from '../service/formulas/formulas';
import { StandardFormulas } from '../service/formulas/standardFormulas';

import { CommonService } from '../service/common.service';

import { HttpClientModule } from '@angular/common/http';
import { Network } from '@ionic-native/network/ngx';

import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { DynamicModule } from 'ng-dynamic-component';

@NgModule({
  declarations: [App, ErrorDialog, AlertDialog, ConfirmDialog, GCodeDialog, PdfInfoDialog, WorkOfflineDialog],
  imports: [
    BrowserModule,
    HttpClientModule,
    ReactiveFormsModule,
    KnobModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    CacheModule.forRoot(),
    MatButtonModule,
    MatCheckboxModule,
    MatAutocompleteModule,
    BrowserAnimationsModule,
    MatDatepickerModule,
    MatSliderModule,
    MatInputModule,
    MatRadioModule,
    MatSelectModule,
    MatGridListModule,
    MatCardModule,
    MatTabsModule,
    MatProgressBarModule,
    MatIconModule,
    MatDialogModule,
    MatTooltipModule,
    MatSnackBarModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    NouisliderModule,
    CompleteRegistrationPageModule,
    ForgottenPasswordPageModule,
    LoginPageModule,
    RegistrationPageModule,
    ResetPasswordPageModule,
    ToolPageModule,
    MatMenuModule,
    DynamicModule
  ],
  bootstrap: [App],
  entryComponents: [ErrorDialog, AlertDialog, ConfirmDialog, GCodeDialog, PdfInfoDialog, WorkOfflineDialog],
  providers: [
    AndroidPermissions,
    File,
    FileTransfer,
    FileTransferObject,
    FileOpener,
    Deeplinks,
    ApplicationConfig,
    StatusBar,
    SplashScreen,
    Utils,
    HttpClientModule,
    Network,
    Constants,
    ImageConstants,
    ErrorDialog,
    AlertDialog,
    ConfirmDialog,
    GCodeDialog,
    PdfInfoDialog,
    WorkOfflineDialog,
    MaterialProvider,
    EndmillProvider,
    CommonService,
    ConversionFormulas,
    Formulas,
    StandardFormulas,
    { provide: LocationStrategy, useClass: HashLocationStrategy }
  ]
})
export class AppModule {}
